import { render, staticRenderFns } from "./GroupMemberItem.vue?vue&type=template&id=6df47510&scoped=true&"
import script from "./GroupMemberItem.vue?vue&type=script&lang=js&"
export * from "./GroupMemberItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberItem.vue?vue&type=style&index=0&id=6df47510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df47510",
  null
  
)

export default component.exports